<script>
import router from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "OrderWrapper",
  props: {
    dashboardOrders: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      current_page: 1,
      orders: [],
      paginationMeta: [],
    }
  },
  methods: {
    async changePage(page) {

      await this.setOrders(page)

      this.current_page = page

      this.$emit("current_page", page);
    },
    async setOrders(page = 1) {
      let response = []
      if (this.dashboardOrders) {
        response = await this.$store.dispatch('ShoppingCart/getAllOrdersWithOrderItems', page)
      } else {
        response = await this.$store.dispatch('ShoppingCart/getOrders', page)
      }

      let data = response.data.data

      this.orders = data.data
      this.paginationMeta = data.meta

      this.$emit("products", this.products);
    },
    async initWrapper() {

      // get orders
      await this.setOrders()

    }
  },
  render() {
    return this.$slots.default({
      orders: this.orders,
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
      current_page: this.current_page,
    });
  },
  async mounted() {
    await this.initWrapper();
  },
}
</script>
